import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import "../../css/Faq.css";

const FAQS = [
  {
    question: "What technologies are you proficient in?",
    answer:
      "I work across the stack: front-end with React and modern JavaScript, back-end with Python, and databases with SQL. I'm comfortable with version control (Git), build tooling, and the IT-systems side — networking, endpoint management, and security fundamentals.",
  },
  {
    question: "What is your development process like?",
    answer:
      "I follow a structured, Agile-informed approach: planning and requirement gathering, close collaboration throughout, Git-based version control, thorough testing at each stage, and reliable deployment with ongoing maintenance support.",
  },
  {
    question: "Do you have experience working on projects similar to mine?",
    answer:
      "Most likely. My portfolio spans company websites, single-page applications, and systems like an online gas ordering and delivery platform — a good range of project types and complexity.",
  },
  {
    question: "What are your rates?",
    answer:
      "Rates depend on scope, complexity, and timeline. Smaller projects are typically hourly; larger, well-defined projects get a fixed quote. I'm always happy to discuss your specific needs and provide a tailored proposal.",
  },
  {
    question: "How do you handle revisions and feedback?",
    answer:
      "Open communication and collaboration are core to how I work. I actively encourage feedback throughout and readily incorporate revisions to ensure you're satisfied with the result.",
  },
  {
    question: "What are your career goals?",
    answer:
      "I'm passionate about building software and constantly learning new technologies. Long term, I aim to grow into a lead engineering role spanning both software development and IT systems.",
  },
];

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex((current) => (current === i ? null : i));

  return (
    <section className="section faqs">
      <div className="container">
        <SectionHeading
          eyebrow="FAQ"
          title="Frequently asked questions"
        />

        <div className="faqs__list">
          {FAQS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.question}
                className={`faq-item ${isOpen ? "is-open" : ""}`}
              >
                <button
                  type="button"
                  className="faq-item__question"
                  aria-expanded={isOpen}
                  onClick={() => toggle(i)}
                >
                  <span>{item.question}</span>
                  <span className="faq-item__icon">{isOpen ? "−" : "+"}</span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="faq-item__answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                      <p>{item.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
